import { z } from 'zod'

/**
 * Validated build-time environment. Only VITE_* variables reach the browser.
 * Empty VITE_API_URL means same-origin (dev proxy / Caddy in production).
 */
const schema = z.object({
  VITE_API_URL: z.string().default(''),
  MODE: z.enum(['development', 'production', 'test']),
  DEV: z.boolean(),
})

export const env = schema.parse(import.meta.env)
